export default {
  paper: {
    position: 'relative',
    zIndex: 100,
    background: '#fff',
    boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.2)',
    borderRadius: 8,
  },
};
